
import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Notes } from "components/Notes/Notes";
import { TabBar } from "components/Tabbar/Tabbar";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useState } from "react";
import { MessageType } from "types/enum";
import { DYNAMICFORMS } from "utils/dynamicForms";
import { downloadCSV, getGridSetting, getPageSize, trans } from "utils/helpers";
import { getDynamicForm, getSalesRequest, postResendJobOrder } from "./api";
import { ModalStepper } from "components/ModalStepper/ModalStepper";




export const SalesRequests = () => {
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [response, setResponse] = useState<any>([]);
    const [selectedObj, setSelectedObj] = useState<string | any>(null);
    const [mode, setMode] = useState<any>("");
    const [modalFormLabel,setModalFormLabel]=useState<any>('')

    const [forceUpdate, setForceUpdate] = useState(false);
    const [showSalesRequestForm, setShowSalesRequestForm] = useState(false);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
const [showNotes,setShowNotes]=useState(false)


        let [dynamicForm, setDynamicForm] = useState<any>("");
    
    const [ShowDynamicFormViewLoading, setShowDynamicFormViewLoading] = useState(false);

    const [selectedStartingProcessId, setSelectedStartingProcessId] = useState<string | any>(null);

    const [search, setsearch] = useState(null);
    const [filterAndSort, setFilterAndSort] = useState<any>(null);
    const layoutContext = useContext(LayoutContext);
    const [pages, setPages] = useState<number>(0);

    const searchHandler = (str) => {
        setPageNum(1);
        setSelectedObj(null)
        if (str === "") {
            setsearch(null)
            getSalesRequestsAsync(1, null);
        } else {
            setsearch(str)
            getSalesRequestsAsync(1, str);
        }
    }
const postResendJobOrderAsync=async()=>{
    try{
        await postResendJobOrder(selectedObj?.Id)
    }
    catch(error){}
}
    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("SalesRequestList", e.currentTarget.value)
        getSalesRequestsAsync(1);
    };
    const handleGoPage = (value) => {
        if (value) {
            setPageNum(+value);
            getSalesRequestsAsync(+value);
        } else {
        }
    };
    const handleNextPage = () => {
        if (response.TotalRecords && ((response.TotalRecords / pageSize) > pageNum)) {
            setPageNum((pageNum) => { return +pageNum + 1 });
            getSalesRequestsAsync(pageNum + 1);

        }
    };
    const handlePrevPage = () => {
        if (pageNum > 1) {
            setPageNum((pageNum) => { return +pageNum - 1 });
            getSalesRequestsAsync(pageNum - 1);
        }
    };



    const selectedObjCallback = (obj, index) => {
        setSelectedObj(obj);
    }

    const handleCreateSalesRequest = (id) => {
        setMode("create");
        setShowSalesRequestForm(true)
    }


    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel": downloadCSV(response?.Data ,6 ,trans("SalesRequestList")); break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "create": handleCreateSalesRequest(""); break;
            case "view": if (selectedObj) {  setMode("view");{setMode("view");  processViewCallback(selectedObj?.ReferenceId); } } else {
                //  Toast(trans("Msg_SelectRow"), "warning")
                Toast(trans("Msg_SelectRow"), MessageType.warning)

                 } break;
            // case "edit": if (selectedObj){setMode("edit");setShowSalesRequestForm(true)}; break;
            case "help": alert("call api help"); break;

        }
    };
    /* #endregion */


    async function getSalesRequestsAsync(pagNum = pageNum, searchSTR = search) {
        setLoading(false)
        try {
        let pageSizeChangedByUser = getPageSize("SalesRequestList")
        setPageSize(pageSizeChangedByUser)
        if(layoutContext.currentApplication!=undefined){
            const res = await getSalesRequest(pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist)
            if (res.Data.Data.length > 0) {
                setResponse(res.Data)
                
                setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) ;
                
            }
        }
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)

    }



  const processViewCallback = async (id: string) => {
        try {
        setSelectedStartingProcessId(id);
        getFormViewAsync(id);
    
          } catch (error) {
            
          }

    };




  async function getFormViewAsync(id: string) {
            setShowDynamicFormViewLoading(false)
            try {
            const res = await getDynamicForm(id);
            let data :any= []
            if (res.Data){
    
                res.Data.map((item, index)=>{
                    if(item.Name != "SignatureForm"){
                        if(res.Data?.[index+1] &&  res.Data?.[index+1]?.Name =="SignatureForm" ){
                            data.push({...item , 
                                forms :[res.Data[index+1]]
                            })
                        }else{
                            data.push(item)
                        }
                    }
        
                })
                setDynamicForm(data);
            } else
                setDynamicForm(undefined);
            if (data) {
                setShowSalesRequestForm(true);
            }
            else { setShowSalesRequestForm(false) }            
            } catch (error) {
                setMessageType("error")
            }
            setShowDynamicFormViewLoading(true)
        }

    useEffect(() => {
        setSelectedObj(null)
        setResponse(null)
        if(filterAndSort!=null&&layoutContext.currentApplication!=undefined){
            getSalesRequestsAsync();
        }
    }, [forceUpdate, filterAndSort ,layoutContext.currentApplication]);
    useEffect(() => {
        let settings = getGridSetting("SalesRequestList")
        setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] })

    }, []);


    return (
        <>  
{showSalesRequestForm &&
                    <ModalForm
                    //  buttonPrintObj={buttonPrintObj}
                       mode={mode} 
                       modalProfileKey={ShowDynamicFormViewLoading ?(dynamicForm[0]?.Name) :"cartableView"}
                    title={!DYNAMICFORMS[dynamicForm[0]?.Name] ?modalFormLabel:ShowDynamicFormViewLoading ?(dynamicForm[0]?.Name) :"cartableView"}
                    onHide={() => { setShowSalesRequestForm(false)}} show={showSalesRequestForm}>                       
                        {ShowDynamicFormViewLoading ? 
                            <>
                       
                                {showNotes && <Notes refrenceId={selectedObj?.referenceId}/>}

                                <ModalStepper
                                                   parentISCartable={true}
                                                //    buttonPrintObjCallBack={setButtonPrintObj}
                                                   sourceId={selectedObj?.SourceId}
                                                   RequesterPositionId={selectedObj?.RequesterPositionId}
                                                   SourceData={selectedObj?.SourceData}
                                                   closeForm={() => { setShowSalesRequestForm(false) }}
                                                   JobNo={selectedObj?.JobNo}
                                               modalFormLabelCallBack={(e)=>setModalFormLabel(e)}
                                                   inDynamicForms={true}
                                                   jobId={selectedObj?.Id}
                                                   onHide={() => {setShowSalesRequestForm(false) }}
                                                   Id={selectedObj?.ReferenceId}
                                                   parentMode={mode}
                                                   taskTitle={selectedObj?.TaskTitle}
                                                   formList={dynamicForm}
                                                //    styleCondition={currentModalWidth}
                                                   />   
                             </>
                          : <Loading/>
                        }
                    </ModalForm>  
                }

            <Toolbar  
            // edit={true}
            view={true} handleSearch={searchHandler} id={selectedObj} emptyList={response?.TotalRecords == 0} search={true} handleClickToolbar={clickToolbarCallback} />
            <div style={{ overflowY: "auto", 
          height: "70vh",
           scrollbarWidth: "thin" }} className="col-lg-12 mt-0">
                {loading ? <>{
                    response?.Data?.length > 0 ?
                        <div className="card">
                            <div className="card-body p-0">
                                <>
                                    <DataGrid
                                        DoubleClick={(obj) => { setSelectedObj(obj); clickToolbarCallback("view") }}
                                        View={true}
                                        ViewParametr={"NotSeen"}
                                        handlefiltering={(str:any) => {str.Filterlist != undefined  ? setFilterAndSort(str) : setFilterAndSort({...filterAndSort, Filterlist:str})}}
                                        filterStr={filterAndSort.Filterlist}
                                        orderFormatList={filterAndSort.OrderFormat}
                                        orderFormat={(order) => { setFilterAndSort({ ...filterAndSort, OrderFormat: order }) }}
                                        parentName={"SalesRequestList"}
                                        theadData={Object.keys(response.Data[0])}
                                        tbodyData={response.Data}
                                        minCellWidth={80}
                                        selectedRowObjectCallback={selectedObjCallback}
                                        rowSelected={selectedObj}
                                        startIndex={8}
                                        handleView={(e)=>{ setSelectedObj({Id:e}) ;setMode("view");setShowSalesRequestForm(true)}}
                                        handleResend={postResendJobOrderAsync}
                                        totalRecords={response.TotalRecords}
                                        pageNum={pageNum}
                                        pageSize={pageSize}
                                        HandleNextPage={handleNextPage}
                                        HandlePrevPage={handlePrevPage}
                                        handlechangePageSize={handleChangePageSize}
                                        first={() => { getSalesRequestsAsync(pages); setPageNum(pages) }}
                                        end={() => { getSalesRequestsAsync(1); setPageNum(1) }}
                                        handleGoPage={handleGoPage}
                                    />
                                </>
                            </div>
                        </div>
                        :<Message message={"NoDataForPreview"} type={messageType} />
                        
                }</>
                    : <Loading />
                }
            </div>
        </>

    );
}